import React from "react";
import styles from "./Stocks.module.css";
import { useStateContext } from "../../lib/StateContext";
import { actions } from "../../lib/actions";
import { round } from "../../lib/utils";

let calculatingStockValues = false;

function Lottery({ className }) {
  const [state, dispatch] = useStateContext();

  const options = React.useMemo(() => {
    return state.stocks.options;
  }, [state.stocks.options]);

  const bankMoneyAvailable = React.useMemo(() => {
    return state.monies.bank;
  }, [state.monies]);

  const valueInvested = React.useMemo(() => {
    return state.stocks.options.reduce((acc, option) => {
      return acc + option.price * option.owned;
    }, 0);
  }, [state.stocks.options]);

  React.useEffect(() => {
    if (state.tick % 5 === 0 && !calculatingStockValues) {
      calculatingStockValues = true;
      const marketDirection = Math.random() < 0.33 ? -1 : 1;
      console.log("md", marketDirection);
      const stocksNew = options.map((option) => {
        const priceChange =
          (Math.random() < option.marketCorr
            ? marketDirection
            : -1 * marketDirection) *
          (Math.random() * option.price * option.volality);
        console.log(
          "pc",
          Math.random() < 0.5 ? -1 : 1,
          Math.random() * option.price,
          option.price,
          priceChange
        );
        return {
          ...option,
          price: option.price + priceChange,
        };
      });
      dispatch(actions.updateStockPrices(stocksNew));
    } else {
      calculatingStockValues = false;
    }
  }, [state.tick, options, dispatch]);
  return (
    <section className={`${className || ""} ${styles.container}`}>
      <h3>Stocks </h3>
      <div className={styles.stats}>
        Invested: ${round(state.stocks.invested)} / Value: $
        {round(valueInvested)} / Bank Balance: ${round(state.monies.bank)}
      </div>
      <div className={styles.overflowContainer}>
        <table className="table">
          <thead>
            <tr>
              <th>Symbol</th>
              <th>Industry</th>
              <th>Price</th>
              <th>Owned</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {options.map((stock) => (
              <tr key={stock.symbol}>
                <td>{stock.symbol}</td>
                <td>{stock.industry}</td>
                <td>${round(stock.price)}</td>
                <td>{stock.owned}</td>
                <td>
                  <button
                    className="btn btn-primary"
                    disabled={stock.price > bankMoneyAvailable}
                    onClick={() => dispatch(actions.buyStock(stock))}
                  >
                    Buy
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default Lottery;
